import { render, staticRenderFns } from "./IDSResourcesPage.html?vue&type=template&id=f8b6a6ba&external"
import script from "./IDSResourcesPage.js?vue&type=script&lang=js&external"
export * from "./IDSResourcesPage.js?vue&type=script&lang=js&external"
import style0 from "./IDSResourcesPage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports